import React, { useEffect, useRef, useState } from "react";

// Fixed bottom horizontal scrollbar for the visible .sticky-table whose own scrollbar is below the fold.
const pickTarget = () => {
  const vh = window.innerHeight;
  for (const el of document.querySelectorAll(".sticky-table")) {
    if (!el.offsetParent || el.scrollWidth <= el.clientWidth + 1) continue;
    const r = el.getBoundingClientRect();
    if (r.top < vh - 40 && r.bottom > vh) return el;
  }
  return null;
};

export function FloatingHScroll() {
  const [box, setBox] = useState(null);
  const barRef = useRef(null);
  const targetRef = useRef(null);
  const syncing = useRef(false);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const el = pickTarget();
      targetRef.current = el;
      if (!el) { setBox(null); return; }
      const r = el.getBoundingClientRect();
      setBox((b) => (b && b.left === r.left && b.width === el.clientWidth && b.sw === el.scrollWidth ? b
        : { left: r.left + el.clientLeft, width: el.clientWidth, sw: el.scrollWidth }));
      if (barRef.current && !syncing.current) barRef.current.scrollLeft = el.scrollLeft;
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };
    window.addEventListener("scroll", schedule, true);
    window.addEventListener("resize", schedule);
    const iv = setInterval(schedule, 800);
    schedule();
    return () => { window.removeEventListener("scroll", schedule, true); window.removeEventListener("resize", schedule); clearInterval(iv); if (raf) cancelAnimationFrame(raf); };
  }, []);

  if (!box) return null;
  const onBarScroll = (e) => {
    const el = targetRef.current;
    if (!el) return;
    syncing.current = true;
    el.scrollLeft = e.currentTarget.scrollLeft;
    requestAnimationFrame(() => { syncing.current = false; });
  };
  return (
    <div ref={barRef} onScroll={onBarScroll} className="floating-hscroll" data-testid="floating-hscroll"
      style={{ left: box.left, width: box.width }}>
      <div style={{ width: box.sw, height: 1 }} />
    </div>
  );
}
